module.exports = __webpack_public_path__ + "static/media/timer.e488398a.svg";